import React, { useEffect, useState } from 'react'
import { Card, CardHeader, Row, Col, Dropdown, DropdownToggle, DropdownMenu, Button } from 'reactstrap'
import { TitlePage } from 'components/atoms'
import { ALERT_TYPES } from 'constants/alert-constants'
import PropTypes from 'prop-types'
import CmsNoticebarApiV2 from 'api/v2/admins/cms-noticebar-api-v2'
import CmsNoticebarEditForm from 'domains/cms-noticebar/organisms/edit-form'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  }
}


const CmsNoticebarEditPage = ({ pageUtils }) => {
  const [ noticebar, setNoticebar ] = useState({})

  const [ previewDropdownOpen, setPreviewDropdownOpen ] = useState(true)
  useEffect(() => {
    CmsNoticebarApiV2.get().then((response) => {
      setNoticebar(response.data.noticebar)
    }).catch((error) => {
      pageUtils.setApiErrorMsg(error.response.data)
    })
  }, [ pageUtils ])

  const handleUpdateNoticebar = (values, formikBag) => {
    CmsNoticebarApiV2.update(values)
      .then((response) => {
        setNoticebar(response.data.noticebar)
        pageUtils.setAlertMsg('Sucessfully updated the Noticebar!', ALERT_TYPES.SUCCESS)
      })
      .catch((error) => {
        pageUtils.setApiErrorMsg(error.response.data)
      })
      .finally(() => formikBag.setSubmitting(false))
  }

  return (
    <>
      <TitlePage mainTitle='CMS Noticebar' subTitle='Edit' />
      <Row>
        <Col md={ 5 }>
          <Card>
            <CardHeader>{ 'Preview' }</CardHeader>
            <div className='p-2 text-center' style={{ backgroundColor: '#3c3c3c' }}>
              <Dropdown
                isOpen={ previewDropdownOpen }
                direction='down'
                className='mx-auto text-white'
                toggle={ () => setPreviewDropdownOpen((prevState) => !prevState) }
              >
                <DropdownToggle
                  direction={ 'down' }
                  tag="div"
                  style={{
                    whiteSpace   : 'nowrap',
                    overflow     : 'hidden',
                    textOverflow : 'ellipsis'
                  }}
                  caret
                >
                  { noticebar.title }
                </DropdownToggle>

                <DropdownMenu className='p-3'>
                  <div>
                    { noticebar.content }
                  </div>
                  {
                    noticebar.is_link_active
                      ? (
                        <div className='text-right'>
                          <Button outline color='primary'>{ noticebar.link_text }</Button>
                        </div>
                      )
                      : null
                  }
                </DropdownMenu>
              </Dropdown>
            </div>
            <div className='text-center bg-gray' style={{ height: '50px' }}>
              { 'Navbar' }
            </div>
          </Card>
        </Col>
        <Col md={ 7 }>
          <CmsNoticebarEditForm
            noticebar={ noticebar }
            handleSubmit={ handleUpdateNoticebar }
          />
        </Col>
      </Row>
    </>
  )
}

CmsNoticebarEditPage.propTypes    = propTypes
CmsNoticebarEditPage.defaultProps = defaultProps

export default CmsNoticebarEditPage
